import { Component, OnInit } from '@angular/core';
import { GroupModel } from "../../../shared/classes/GroupModel";
import { GroupsService } from '../../../shared/services/groups.service';
import { Adal4Service } from "adal-angular4";
import { Router, NavigationExtras } from "@angular/router";

@Component({
  selector: 'app-gerenciar-grupos',
  templateUrl: './gerenciar-grupos.component.html',
  styleUrls: ['./gerenciar-grupos.component.css'],
  providers: [GroupsService]
})
export class GerenciarGruposComponent implements OnInit {
  
  listaGroups: GroupModel[] = []
  mostrarCarregando;
  indiceGrupoSelecionado: number = -1;
  grupoSelecionado: GroupModel;
  temp_groupName: string;
  temp_permissionLevel: number;
  isNewGroup: boolean = false;
  disableNewGroupButton = false;
  msgAviso: string;
  class_fa_icon_ok = "fa fa-thumbs-o-up fa-3x text-success";
  class_fa_icon_nok = "fa fa-thumbs-o-down fa-3x text-error";
  class_icon_msg: string;
  canUserStorage: boolean = false;
  
  constructor(private _groupsService: GroupsService, private adalService: Adal4Service, private router: Router,) { }

  ngOnInit() {
    
    this.mostrarCarregando = true;
    this._groupsService.getGroups()
    .then(groups => {        
      this.listaGroups = groups;
      this.mostrarCarregando = false;
      localStorage.setItem("grupos", JSON.stringify(this.listaGroups));        
    }).catch(error => {
      this.mostrarCarregando = false;
      //console.logconsole.log("error",error.status)
      this.msgAviso = error.text();
      if(error.status == 403 || error.status == 401){
        this.msgAviso = "Sua sessão expirou ou você não tem permissão para acessar este recurso.";
        //this.router.navigate(['/home']);           
      }
      this.class_icon_msg = this.class_fa_icon_nok;
      document.getElementById("showMensagensModal3").click();
    });
        
  }

  // disableFields(){
  //   if(this.listaGroups.length > 0){
  //    for (var index = 0; index < this.listaGroups.length; index++) {
  //      (<HTMLInputElement> document.getElementById("inputGroupName"+index)).disabled = true; 
  //      (<HTMLInputElement> document.getElementById("selectGroupPermission"+index)).disabled = true;   
  //    }
  //   }
  // }

  // editGroup(indexReport: number){
  //   this.indiceGrupoSelecionado = indexReport;
  //   this.temp_groupName = this.listaGroups[indexReport].groupName;
  //   this.temp_permissionLevel = this.listaGroups[indexReport].permissionLevel;
  //   (<HTMLInputElement> document.getElementById("inputGroupName"+indexReport)).disabled = false; 
  //   (<HTMLInputElement> document.getElementById("selectGroupPermission"+indexReport)).disabled = false; 
  //   (<HTMLInputElement> document.getElementById("btnSalvar")).disabled = false; 
  //   (<HTMLInputElement> document.getElementById("btnCancelar")).disabled = false;    
  // }

  // cancelAction(){    
  //   if(this.indiceGrupoSelecionado >= 0){
  //     if(!this.isNewGroup){
  //       var i = this.indiceGrupoSelecionado;
  
  //       this.listaGroups[i].groupName = this.temp_groupName;
  //       this.listaGroups[i].permissionLevel = this.temp_permissionLevel;
        
  //       (<HTMLInputElement> document.getElementById("inputGroupName"+i)).disabled = true; 
  //       (<HTMLInputElement> document.getElementById("selectGroupPermission"+i)).disabled = true; 
        
  //     }else{
  //       this.listaGroups.pop();
  //       this.isNewGroup = false;
  //       this.enableButtonNew();        
  //     }       
  //     this.disableSaveCancel();
  //   }
  // }

  // saveGroup(){
  //   if(this.indiceGrupoSelecionado >= 0){
  //     var i = this.indiceGrupoSelecionado;
  //     if(!this.isNewGroup){
  //       if(this.listaGroups[i].groupName != this.temp_groupName 
  //         || this.listaGroups[i].permissionLevel != this.temp_permissionLevel){        
  //         var editedGroup = this.listaGroups[this.indiceGrupoSelecionado];
  //         this._groupsService.updateGroup(editedGroup.id, editedGroup).then(group => {
  //           this.msgAviso = "Grupo editado com sucesso! -"+ editedGroup.groupName;
  //           this.listaGroups[i] = group;
  //           localStorage.setItem("grupos", JSON.stringify(this.listaGroups));
  //           this.class_icon_msg = this.class_fa_icon_ok;
  //           document.getElementById("showMensagensModal3").click();
  //           this.disableFields();
            
  //         }).catch(error => {
  //           this.msgAviso = <any>error;
  //           this.class_icon_msg = this.class_fa_icon_nok;
  //           document.getElementById("showMensagensModal3").click();
  //         })
  //       }
  //     }else{
  //       var newGroup = this.listaGroups[i];
  //       if(newGroup.groupName == null || newGroup.groupName == ""){
  //           this.msgAviso = "Você precisa digitar um nome para o grupo.";
  //           this.class_icon_msg = this.class_fa_icon_nok;
  //           document.getElementById("showMensagensModal3").click();
  //         return;
  //       }
  //       this._groupsService.addGroup(newGroup).then(group => {
  //         this.isNewGroup = false;
  //         this.listaGroups[this.indiceGrupoSelecionado] = group;
  //         this.msgAviso = "Grupo criado com sucesso! -"+ group.groupName;
  //         localStorage.setItem("grupos", JSON.stringify(this.listaGroups));
          
  //         this.disableSaveCancel();
  //         this.disableFields();
  //         this.class_icon_msg = this.class_fa_icon_ok;
  //         document.getElementById("showMensagensModal3").click();
  //       }).catch(error => {
          
  //         this.msgAviso = error.text() || <any>error;
  //         this.class_icon_msg = this.class_fa_icon_nok;
  //         document.getElementById("showMensagensModal3").click();
  //       })
  //     }
  //     this.enableButtonNew();
      
  //   }
  // }
  // addGroup(){
  //   (<HTMLInputElement> document.getElementById("btnSalvar")).disabled = false; 
  //   (<HTMLInputElement> document.getElementById("btnCancelar")).disabled = false;
  //   this.disableButtonNew();
  //    var newGroup: GroupModel = new GroupModel();
  //    newGroup.permissionLevel = 1;
  //    this.listaGroups.push(newGroup);
  //    this.indiceGrupoSelecionado = this.listaGroups.length - 1;
  //    this.isNewGroup = true;
  //    this.enableSelectedGroupFields(this.indiceGrupoSelecionado);
     
  // }

  // enableSelectedGroupFields(i:number){
  //  // console.log("i: ", i);
  //   setTimeout(()=> {
  //     (<HTMLInputElement> document.getElementById("inputGroupName"+i)).disabled = false; 
  //     (<HTMLInputElement> document.getElementById("selectGroupPermission"+i)).disabled = false; 
  //   }, 200);    
  // }

  // deleteGroup(){
  //   if(this.indiceGrupoSelecionado < 0){return;}
  //   //console.log(this.grupoSelecionado);
  //   var groupId = this.grupoSelecionado.id;
  //   //console.log("groupId", groupId)
  //   this._groupsService.deleteGroup(groupId).then(() => {
      
  //     this.listaGroups.splice(this.indiceGrupoSelecionado, 1);  
  //     //console.log("lista apos splice", this.listaGroups);   
  //     this.msgAviso = "Grupo excluído com sucesso!";
  //     this.class_icon_msg = this.class_fa_icon_ok;
  //     document.getElementById("showMensagensModal3").click();
  //     localStorage.setItem("grupos", JSON.stringify(this.listaGroups));
  //     //console.log("local storage apos splice", localStorage.getItem("grupos"))
  //   }).catch(error => {
  //     this.msgAviso = error.text() || <any>error;
  //     this.class_icon_msg = this.class_fa_icon_nok;
  //     document.getElementById("showMensagensModal3").click();
  //   })
  // }

  // setIndexGroupToDelete(i:number){
  //  // console.log("i do botão", i)
  //   this.indiceGrupoSelecionado = i;
  //   //console.log("[setIndexGroupToDelete] this.indiceGrupoSelecionado",this.indiceGrupoSelecionado);
  //   this.grupoSelecionado = this.listaGroups[this.indiceGrupoSelecionado];
  // }

  // disableSaveCancel(): any {
  //  (<HTMLInputElement> document.getElementById("btnSalvar")).disabled = true; 
  //  (<HTMLInputElement> document.getElementById("btnCancelar")).disabled = true;
  // }

  // disableButtonNew(){
  //   (<HTMLInputElement>document.getElementById("btnNewGroup")).disabled = true; 
  // }
  // enableButtonNew(){
  //   (<HTMLInputElement>document.getElementById("btnNewGroup")).disabled = false; 
  // }
}



// WEBPACK FOOTER //
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/src/app/paginas/administracao/gerenciar-grupos/gerenciar-grupos.component.ts